import { render, staticRenderFns } from "./Secondlast.vue?vue&type=template&id=198a19df&"
import script from "./Secondlast.vue?vue&type=script&lang=js&"
export * from "./Secondlast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports